import type { BelongingsFeatureConfig } from '../../../types/insurances/BelongingsFeatureConfig';

export const belongings: BelongingsFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: true,
            showVariant: false,
            showPackage: true,
            showContractHolder: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: 'SK_PERSONAL_BELONGINGS_AND_CARDS',
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
